"use strict";
/**
 *
 *
 *
 * notifications:
 *  - update
 *  - sign-in
 *  - sign-out
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var axios_1 = __importDefault(require("axios"));
var BaseService_1 = require("./BaseService");
var UrlState_1 = require("./UrlState/UrlState");
var singleton_1 = require("./singleton");
var AppConfig_1 = require("./AppConfig");
var extractErrorMessage_1 = require("./extractErrorMessage");
function _extractUserId(authCheckData) {
    if (authCheckData.user) {
        return authCheckData.user.id;
    }
    else {
        return parseInt(authCheckData.id);
    }
}
function _extractUserConfig(authCheckData) {
    if ('config' in authCheckData) {
        return authCheckData.config || {};
    }
    // v 2.0
    if ('user' in authCheckData) {
        return authCheckData.user.config || {};
    }
    return {};
}
var AuthenticationModelFactory = /** @class */ (function () {
    function AuthenticationModelFactory() {
    }
    AuthenticationModelFactory._createDefault = function () {
        return {
            authenticated: false,
            userId: null,
            loading: false,
            error: null,
            userConfig: {}
        };
    };
    AuthenticationModelFactory.withLoading = function () {
        var model = AuthenticationModelFactory._createDefault();
        model.loading = true;
        return model;
    };
    AuthenticationModelFactory.withError = function (error) {
        var model = AuthenticationModelFactory._createDefault();
        model.error = error || 'Unknown error';
        return model;
    };
    AuthenticationModelFactory.withSignedOut = function () {
        var model = AuthenticationModelFactory._createDefault();
        return model;
    };
    AuthenticationModelFactory.withSignedIn = function (authCheckData) {
        var model = __assign(__assign(__assign({}, authCheckData), AuthenticationModelFactory._createDefault()), { authenticated: true, userId: _extractUserId(authCheckData), userConfig: _extractUserConfig(authCheckData) });
        return model;
    };
    return AuthenticationModelFactory;
}());
function _isHttpErrorIsNotAuthenticated(error) {
    if (!error.isAxiosError)
        return false;
    if (!error.response)
        return false; // network error
    if (error.response.status === 403 || error.response.status === 401) {
        var response = error.response;
        try {
            var _a = response.data, key = _a.key, type = _a.type, message = _a.message;
            if (key === 'INVALID_SESSION' ||
                key === 'WRONG_PASSWORD_OR_USER_NAME' ||
                key === 'SESSION_NOT_FOUND') {
                return true;
            }
            if (error.response.status === 401) {
                return true;
            }
        }
        catch (err) {
            // invalid json?
        }
        // on signIn failed: the body is 'null\n' and status=401
        if (response.data === null) {
            // login return 401
            return true;
        }
        // Admin returns HTML with code 403 instead of result
        if (typeof response.data === 'string' && response.data.startsWith('<!doctype html>')) {
            return true;
        }
    }
    return false;
}
var AuthenticationService = /** @class */ (function (_super) {
    __extends(AuthenticationService, _super);
    function AuthenticationService() {
        var _this = _super.call(this) || this;
        axios_1["default"].interceptors.response.use(function (response) { return response; }, function (error) {
            if (_isHttpErrorIsNotAuthenticated(error)) {
                _this._notifyLoggedOut();
            }
            return Promise.reject(error);
        });
        _this._model = AuthenticationModelFactory.withLoading();
        _this._init();
        return _this;
    }
    AuthenticationService.prototype._init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authCheckData, err_1, errorResponse, errorKey, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.check()];
                    case 1:
                        authCheckData = _a.sent();
                        if (authCheckData) {
                            this._setModel(AuthenticationModelFactory.withSignedIn(authCheckData));
                        }
                        else {
                            this._setModel(AuthenticationModelFactory.withSignedOut());
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        errorResponse = null, errorKey = void 0, errorMessage = void 0;
                        try {
                            errorResponse = err_1.response.data;
                        }
                        catch (err2) {
                            /* */
                        }
                        if (errorResponse && errorResponse.authRedirect) {
                            return [2 /*return*/];
                        }
                        if (errorResponse) {
                            errorKey = errorResponse.key;
                            errorMessage = errorResponse.message;
                        }
                        if (errorResponse && errorResponse.key === 'LOGIN_COUNT_LIMIT_EXCEEDED') {
                            this._updateModel({
                                loading: false,
                                error: errorResponse.message,
                                isBlocked: true,
                                errorKey: errorKey,
                                errorMessage: errorMessage
                            });
                            return [2 /*return*/];
                        }
                        //
                        this._setModel(__assign(__assign({}, AuthenticationModelFactory.withError(extractErrorMessage_1.extractErrorMessage(err_1))), { errorKey: errorKey,
                            errorMessage: errorMessage }));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype._setModel = function (m) {
        var prevModel = this._model;
        var prevAuthenticated = prevModel ? prevModel.authenticated : false;
        _super.prototype._setModel.call(this, m);
        // TODO: compare with prevModel (= this._model)
        if (prevAuthenticated !== m.authenticated) {
            if (m.authenticated) {
                this._notify('sign-in', this._model);
            }
            else {
                this._notify('sign-out', this._model);
            }
        }
    };
    AuthenticationService.prototype.isAuthenticated = function () {
        return this._model.authenticated;
    };
    AuthenticationService.prototype._check = function () {
        return __awaiter(this, void 0, void 0, function () {
            var urlState, url, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlState = UrlState_1.UrlState.getModel();
                        if (AuthenticationService.FORCE_LOGIN_KEY in urlState) {
                            return [2 /*return*/, null];
                        }
                        url = AppConfig_1.AppConfig.fixRequestUrl('/api/auth/check');
                        return [4 /*yield*/, axios_1["default"].get(url)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AuthenticationService.prototype.check = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_2, errorResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._check()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                    case 2:
                        err_2 = _a.sent();
                        errorResponse = null;
                        try {
                            errorResponse = err_2.response.data;
                        }
                        catch (err2) {
                            //
                        }
                        if (errorResponse && errorResponse.authRedirect) {
                            console.log('Auth with redirect', errorResponse.authRedirect);
                            window.location.href = errorResponse.authRedirect;
                            throw err_2;
                        }
                        if (errorResponse && errorResponse.key === 'LOGIN_COUNT_LIMIT_EXCEEDED') {
                            throw err_2;
                        }
                        if (_isHttpErrorIsNotAuthenticated(err_2)) {
                            return [2 /*return*/, null];
                        }
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype._notifyLoggedOut = function () {
        this._setModel({
            authenticated: false,
            loading: false,
            error: null
        });
    };
    AuthenticationService.prototype.signIn = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, data, nonCompleteModel, FORCE_LOGIN_KEY, err_3, errorResponse;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._model.authenticated) {
                            console.warn('[AuthenticationService] [sign-in] already authenticated');
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        this._setModel(AuthenticationModelFactory.withLoading());
                        url = AppConfig_1.AppConfig.fixRequestUrl("/api/auth/login");
                        return [4 /*yield*/, axios_1["default"]({
                                method: 'post',
                                url: url,
                                data: "username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password),
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                            })];
                    case 2:
                        result = _b.sent();
                        data = result.data;
                        if (data && data.authType === '2fa') {
                            nonCompleteModel = AuthenticationModelFactory.withSignedIn(data);
                            nonCompleteModel.authenticated = false;
                            nonCompleteModel.isNeed2FACode = true;
                            this._setModel(nonCompleteModel);
                            return [2 /*return*/, this._model];
                        }
                        if (!!(data && ('user' in data || 'id' in data))) return [3 /*break*/, 4];
                        console.warn('[AuthenticationService] Login returned null', data);
                        return [4 /*yield*/, this._check()];
                    case 3:
                        // data is null! login does not return anything
                        // TODO: make login return info
                        data = _b.sent();
                        _b.label = 4;
                    case 4:
                        FORCE_LOGIN_KEY = AuthenticationService.FORCE_LOGIN_KEY;
                        if (FORCE_LOGIN_KEY in UrlState_1.UrlState.getModel()) {
                            UrlState_1.UrlState.navigate((_a = {}, _a[FORCE_LOGIN_KEY] = null, _a));
                        }
                        this._setModel(AuthenticationModelFactory.withSignedIn(data));
                        return [2 /*return*/, this._model];
                    case 5:
                        err_3 = _b.sent();
                        if (_isHttpErrorIsNotAuthenticated(err_3)) {
                            this._setModel(AuthenticationModelFactory.withSignedOut());
                            return [2 /*return*/, this._model];
                        }
                        // HTTP 449: 2fa
                        try {
                            errorResponse = err_3.response.data;
                            if (errorResponse.authType === '2fa') {
                                this._setModel({
                                    error: null,
                                    loading: false,
                                    authenticated: false,
                                    isNeed2FACode: true
                                });
                                return [2 /*return*/, this._model];
                            }
                        }
                        catch (xErr) {
                            //
                        }
                        console.error('[AuthenticationService] Failed to login:', err_3);
                        this._setModel(AuthenticationModelFactory.withError(extractErrorMessage_1.extractErrorMessage(err_3)));
                        throw err_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = AppConfig_1.AppConfig.fixRequestUrl("/api/auth/logout");
                        return [4 /*yield*/, axios_1["default"].get(url)];
                    case 1:
                        _a.sent();
                        this._notifyLoggedOut();
                        if (typeof window !== 'undefined')
                            window.location.reload(); // forget everything
                        return [2 /*return*/, this._model];
                }
            });
        });
    };
    AuthenticationService.prototype.resendCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = AppConfig_1.AppConfig.fixRequestUrl("/api/auth/2fa/resend-factor2");
                        return [4 /*yield*/, axios_1["default"].get(url)];
                    case 1:
                        result = (_a.sent()).data;
                        console.log('resend code', result);
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.prototype.signInWithCode = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = AppConfig_1.AppConfig.fixRequestUrl('/api/auth/2fa/login2');
                        return [4 /*yield*/, axios_1["default"].post(url, { factor2: parseInt(code, 10) })];
                    case 1:
                        data = (_a.sent()).data;
                        // might be ok!
                        this._setModel(AuthenticationModelFactory.withSignedIn(data));
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        console.error(err_5);
                        throw err_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    //
    // static methods for easy use
    //
    AuthenticationService.getModel = function () {
        return this.getInstance().getModel();
    };
    AuthenticationService.subscribeUpdatesAndNotify = function (listener) {
        return this.getInstance().subscribeUpdatesAndNotify(listener);
    };
    AuthenticationService.subscribeUpdates = function (listener) {
        return this.getInstance().subscribeUpdates(listener);
    };
    AuthenticationService.unsubscribe = function (listener) {
        return this.getInstance().unsubscribe(listener);
    };
    AuthenticationService.signOut = function () {
        return this.getInstance().signOut();
    };
    AuthenticationService.signInWithCode = function (code) {
        return this.getInstance().signInWithCode(code);
    };
    AuthenticationService.signIn = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getInstance().signIn(username, password)];
            });
        });
    };
    AuthenticationService.resendCode = function () {
        return this.getInstance().resendCode();
    };
    AuthenticationService.NOT_AUTHENTICATED = 'Not authenticated';
    AuthenticationService.FORCE_LOGIN_KEY = 'loginme';
    AuthenticationService.getInstance = singleton_1.createSingleton(function () { return new AuthenticationService(); }, '__authenticationService');
    return AuthenticationService;
}(BaseService_1.BaseService));
exports.AuthenticationService = AuthenticationService;
